import React from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import useMobileDetect from '@/lib/hooks/useMobileDetect';

const FollowUsRightContent2 = ({ qrCodeImageUrls, mediaName }: { qrCodeImageUrls: string[]; mediaName?: string[] }) => {
  const t = useTranslations();
  const { isMobile } = useMobileDetect();

  return (
    <div
      style={{
        backgroundImage: `url(${isMobile ? '/images/home/followUsBgForH5.png' : '/images/home/followUsBg.png'})`,
        backgroundSize: '100% 100%',
      }}
      className="flex h-full w-full flex-col items-center justify-center bg-center bg-no-repeat"
    >
      <div className="mb-[2.5%] text-center text-[1.248vw] font-bold text-[#212136] max-md:hidden max-md:text-[2.926vw]">{`>> ${t('Home.followUsRightText2')} <<`}</div>
      <div className="flex w-full flex-row items-start justify-center">
        <div className="mr-[6.23%] aspect-square w-[37.4%] max-md:w-[35%]">
          <Image src={qrCodeImageUrls[0]} alt="weixin" width={300} height={300} className="aspect-square w-full" />
          {mediaName?.[0] && (
            <div className="mt-[6%] text-center text-[2.926vw] text-[#111111] md:hidden">{mediaName?.[0]}</div>
          )}
        </div>
        <div className="aspect-square w-[37.4%] max-md:w-[35%]">
          <Image src={qrCodeImageUrls[1]} alt="weixin" width={300} height={300} className="aspect-square w-full" />
          {mediaName?.[1] && (
            <div className="mt-[6%] text-center text-[2.926vw] text-[#111111] md:hidden">{mediaName?.[1]}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowUsRightContent2;
